import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _themes = [];

let ThemeStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    emitChangeForm: function() {
        this.emit(FORM_CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    getById: function(id) {
        return _themes.find(function(e) {
            return e !== undefined && e.id == id;
        });
    },
    getAll: function() {
         return _themes;
    },

});

ThemeStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {
        case ActionTypes.THEME_LIST:
            _themes = action.data;
            ThemeStore.emitChange();
            break;

        case ActionTypes.THEME_LIST_ERROR:
            ThemeStore.emitChange();
            break;

        default:
            break;
    }

});

export default ThemeStore;
